  <div  class="categoryDiv"  (click)="onClickCategory()">
    <div class="m-auto"  >
      <div class="image2" >
        <div  class="divInImage2"  >
       
      <img class="image3" [src]="categoryItem.ImgFile" >
    
    
    </div>
  
        <div class="divBottonCategory">
    <div class="categoryTop" >{{categoryItem.Category}}</div>
  
    <div class="place">{{categoryItem.Count}} מקומות</div>
   
  </div>
  <div >
  </div> 
  </div>
      </div>
  </div>